module.exports = __webpack_public_path__ + "img/law-serve-nav-icon10.6586443e.png";